<template>
	<div>
		<!-- Header Component -->
		<Header></Header>

		<!-- Navigation -->
		<Navigation v-if="$vuetify.breakpoint.smAndDown">
			<v-list-item link @click="$router.push({ name: 'PurchasesIndex' })">
				<v-list-item-content>
					<v-list-item-title>
						Ordenes de compra
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item link class="list-item-logout" @click="logout()">
				<v-list-item-content>
					<v-list-item-title>
						Cerrar sesión
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</Navigation>

		<div class="pa-container">
			<!-- Router View -->
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import { EventBus } from "@/main";

// Components
import Header from "@/components/Header";
import Navigation from "@/components/Navigation";

export default {
	name: "Profile",

	components: {
		Header,
		Navigation,
	},

	data() {
		return {};
	},

	created() {
		this.$store.dispatch(
			"getArticles",
			this.$store.state.acount.user.customer.id
		);
	},

	methods: {
		logout() {
			EventBus.$emit("Logout");
		},
	},
};
</script>

<style lang="css" scoped></style>
